import { useContext, useEffect, useState } from "react";
import RequiredDocumentsModal from "./RequiredDocumentsModal";
import MissingDocument from "./missingDocument";
import AuthenticateYourId from "./authenticateYourId";
import DocumentScanning from "./documentScanning";
import AuthContext from "../../context/auth/AuthContext";
import axiosInstance from "../../services/authWrapper";
import BasicInfoModal from "./BasicInfoModal";
import constants from "../../Utils/constants";
import Loader from "../../components/Loader";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { useLocation, useNavigate } from "react-router-dom";
import TenantContext from "../../context/tenant/TenantContext";
import useTranslator from "../../hooks/useTranslator";
import { sendUniversalMail } from "../../services/sharedService";
import { haveValue, toast } from "../../helper/common";
import { useCookies } from "react-cookie";
import BankModal from "./BankModal";
import GuarantorModal from "./GuarantorModal";
import PendingRequestsPopup from "../../components/Tenant/Guarantor/PendingRequestsPopup";
import FlatmateOrGuarantorAddForm from "../../components/TenantDetails/FlatmateOrGuarantorAddForm";
import FreeTextModal from "../../components/Tenant/FreeTextModal";
import ConsentStepModal from "./ConsentStepModal";
import RequestAcceptingModal from "../../components/Tenant/Guarantor/RequestAcceptingModal";

function OnboardingMain() {
  const { _t } = useTranslator();
  const navigate = useNavigate();

  const authContext = useContext(AuthContext);
  const { user: originalUser, loadUser, getPendingGuaantees } = authContext;
  const {
    createBasicGuarantorAccount,
    updateBasicGuarantorAccount,
    guarantorAddedDetails,
    deleteSelectedOnboardingUser,
    shareProfile,
  } = useContext(TenantContext);
  const location = useLocation();
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [pageLoading, setPageLoading] = useState(false);
  const [documentAnalysisResponse, setDocumentAnalysisResponse] = useState({});
  const [selectedOnboardingUsers, setSelectedOnboardingUsers] = useState([]);
  const [user, setUser] = useState({});
  const [showGuarantorModel, setShowGuarantorModel] = useState(false);
  const [guarantorAccountPresent, setGuarantorAccountPresent] = useState(false);
  const isGuarantor = location.pathname === "/guarantor/onboarding";
  const queryParameters = new URLSearchParams(window.location.search);
  const guarantor_a_id = queryParameters.get("guarantor_a_id");
  const isFirstTime = queryParameters.get("welcome");
  const guarantorName = queryParameters.get("guarantorName");
  // For Edit user
  const isEditMode = location.pathname === "/user/edit";
  const paramStep = queryParameters.get("step");
  const edit_step = parseInt(paramStep ?? "", 10);
  // For Edit user
  const [runDetectKycDocs, setRunDetectKycDocs] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [selectedProtectedHousingDocs, setSelectedProtectedHousingDocs] =
    useState([]);
  const [addedFiles, setAddedFiles] = useState([]);
  const [pendingGuaranteesRequests, setPendingGuaranteesRequests] = useState(
    []
  );
  const [pendingRequestsGuranteesLoading, setPendingRequestsGuranteesLoading] =
    useState(false);
  const [lessGuarantorInfoModal, setlessGuarantorInfoModal] = useState(false);

  // Share profile logic starts
  const [cookies, setCookie, removeCookie] = useCookies(["sharedProfileLink"]);

  //accept modal
  const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
  const [acceptedGuaranteeName, setAcceptedGuaranteeName] = useState("");

  useEffect(() => {
    const guarantorFor = localStorage.getItem("guarantorFor");
    if (haveValue(guarantorFor)) {
      loadPendingGuarantees({ requested_tenant_id: guarantorFor });
    }
  }, [localStorage.getItem("guarantorFor")]);

  useEffect(() => {
    const user_type = localStorage.getItem("usertype");
    const userId = localStorage.getItem("saveduserid");
    if (haveValue(cookies.requestProfileLink) && user_type == "tenant") {
      if (haveValue(userId)) {
        const havePropertyId = haveValue(cookies.property_id);
        const invitationToken = haveValue(cookies.invitationToken);
        const payload = {
          shareType: "lLink",
        };
        if (havePropertyId) {
          payload.property_id = cookies.property_id;
        }
        shareProfile(
          userId,
          cookies.requestProfileLink,
          "null",
          "full",
          payload
        )
          .then((res) => {
            removeCookie("requestProfileLink", { maxAge: 1800 });
            if (havePropertyId) {
              removeCookie("property_id", { maxAge: 1800 });
            }
            if (invitationToken) {
              removeCookie("invitationToken", { maxAge: 1800 });
            }
          })
          .catch((err) => {});
      }
    }
  }, []);
  // Share profile logic ends

  const applyProfileData = (_user) => {
    setFormData({
      fname: _user?.fname || "",
      lname: _user?.lname || "",
      identity_number: _user?.dni_nie || _user?.passport_id || "",
      post_code: _user?.post_code || "",
      dob: _user?.dob ? _user.dob.split("T")[0] : "",
      employment_status: _user?.employment_status || "",
      employment_category: _user?.employment_category || "",
      current_annual_income: _user?.current_annual_income ?? "",
      protected_housing: _user?.protected_housing || false,
      email: _user?.email || "",
      gurantor_relation: _user?.gurantor_relation || "",
      phone_number: _user?.phone_number || "",
      currency: _user?.currency || "EUR",
    });
    setPhoneNumber(_user?.phone_number || "");
    setSelectedProtectedHousingDocs(
      !_user?.protected_housing
        ? ["no"]
        : _user?.tenant_extra_field_id?.public_housing_docs
    );
    if (!isEditMode) {
      setStep(_user?.step ?? 1);
    } else {
      setStep([1, 2, 3].includes(Number(edit_step)) ? Number(edit_step) : 1);
    }
  };

  const loadData = async () => {
    try {
      setPageLoading(true);
      await loadUser("tenant");
    } finally {
      setPageLoading(false);
    }
  };
  const loadGuarantorData = async (loadFor, gur_id, needLoading) => {
    try {
      if (needLoading) {
        setPageLoading(true);
      }
      const res = await guarantorAddedDetails(gur_id ?? guarantor_a_id);
      if (loadFor === "applyProfile") {
        setUser(res?.success_res?.guarantor_id);
        applyProfileData({
          ...res?.success_res?.guarantor_id,
          gurantor_relation: res?.success_res?.gurantor_relation,
        });
      }
      return res;
    } catch (err) {
      console.log("Error updating guarantor", err);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    if (isGuarantor) {
      if (step === 1 && !guarantor_a_id) {
        setShowGuarantorModel(true);
      }
      if (guarantor_a_id) {
        loadGuarantorData("applyProfile");
      } else {
        applyProfileData({});
      }
      // loading original user
      loadData();
    } else {
      // loading original user
      loadData();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!isGuarantor) {
      setUser(originalUser);
      applyProfileData(originalUser);
      // loadPendingGuarantees();
    }
  }, [originalUser, location.pathname]);

  const upsertUserProfile = async (data) => {
    try {
      let res;
      if (isGuarantor) {
        if (guarantor_a_id) {
          const updatedPayload = {
            ...data,
            guarantor_id: guarantor_a_id,
          };
          res = await updateBasicGuarantorAccount(updatedPayload);
          await loadGuarantorData("applyProfile");
        } else {
          res = await createBasicGuarantorAccount(data);
          if (res.created_guarantor_id) {
            if (haveValue(guarantorName)) {
              const payload = {
                tenant_id: originalUser?._id,
                type: "guarantor",
                name: guarantorName,
                guarantor_id: res.guarantor_id ?? null,
              };
              await deleteSelectedOnboardingUser(payload);
            }
            const url = new URL(window.location.href);
            url.searchParams.set("guarantor_a_id", res.created_guarantor_id);
            window.history.pushState({}, "", url.toString());
          }
          await loadGuarantorData("applyProfile", res.created_guarantor_id);
        }
      } else {
        if (!haveValue(data?.is_edit)) {
          data.is_edit = true;
        }
        res = await axiosInstance.patch(
          `${process.env.REACT_APP_SERVER_URL}/users/profile/${originalUser?._id}`,
          data,
          {
            headers: { "Accept-Language": localStorage.getItem("i18nextLng") },
          }
        );
        const usertype = localStorage.getItem("usertype");
        await loadUser(usertype);
      }

      return res;
    } catch (err) {
      if (err?.response?.data?.errorKey === "account-already-present") {
        setGuarantorAccountPresent(true);
      } else {
        toast.error(
          err?.response?.data?.errormsg ||
            err?.response?.data?.error ||
            "Something went wrong"
        );
      }

      throw err;
    }
  };

  const requiresSubcategory = (status) => {
    return [
      constants.public_servant,
      constants.employed,
      constants.self_employed,
    ].includes(status);
  };

  const formHandler = {
    next: () =>
      setStep((prev) => {
        const newStep = prev + 1;
        if (isEditMode) {
          const params = new URLSearchParams(window.location.search);
          params.set("step", newStep);
          window.history.replaceState(
            {},
            "",
            `${window.location.pathname}?${params.toString()}`
          );
        }
        return newStep;
      }),

    prev: () =>
      setStep((prev) => {
        const newStep = prev > 1 ? prev - 1 : 1;
        if (isEditMode) {
          const params = new URLSearchParams(window.location.search);
          params.set("step", newStep);
          window.history.replaceState(
            {},
            "",
            `${window.location.pathname}?${params.toString()}`
          );
        }
        return newStep;
      }),
  };

  const sendMail = (receiverEmail, emailType) => {
    let payload = {
      receiverEmail: receiverEmail,
      senderId: localStorage.getItem("saveduserid"),
      emailType: emailType,
      status: "processing",
    };
    sendUniversalMail(payload)
      .then((res) => {
        loadUser("tenant");
        toast.success(_t("emailSent"));
      })
      .catch((err) => {
        toast.error(_t("errorSendingMail"), err?.message);
      });
  };
  const handleSendEmailToGuarantor = async (guarantorEmail) => {
    if (guarantorEmail === originalUser?.email) {
      toast.error(
        "youCannotAddYourselfAsGuarantor",
        "Error message when a user is try to add guarantor but add his/her own email"
      );
      return;
    }
    sendMail(guarantorEmail, "score");
    navigate("/home");
    // toast.success(_t("emailSentToGuarantor"));
  };

  const loadPendingGuarantees = async (data) => {
    setPendingRequestsGuranteesLoading(true);
    try {
      const response = await getPendingGuaantees(data);
      setPendingGuaranteesRequests(response?.success_res ?? []);
    } catch (e) {
      console.error(e);
      toast.error(
        _t(
          "failedToLoadPendingRequests",
          "Text used in guarantees pending requests popup"
        )
      );
    } finally {
      setPendingRequestsGuranteesLoading(false);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <BasicInfoModal
            user={user}
            formData={formData}
            setFormData={setFormData}
            createUserProfile={upsertUserProfile}
            formHandler={formHandler}
            requiresSubcategory={requiresSubcategory}
            isGuarantor={isGuarantor}
            guarantorAccountPresent={guarantorAccountPresent}
            originalUser={originalUser}
            setGuarantorAccountPresent={setGuarantorAccountPresent}
            isEditMode={isEditMode}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            selectedProtectedHousingDocs={selectedProtectedHousingDocs}
            setSelectedProtectedHousingDocs={setSelectedProtectedHousingDocs}
          />
        );
      case 2:
        return (
          <RequiredDocumentsModal
            formHandler={formHandler}
            user={user}
            requiresSubcategory={requiresSubcategory}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            isFirstTime={isFirstTime}
            guarantor_a_id={guarantor_a_id}
            needWaitingJobForClave={true}
            isEditMode={isEditMode}
          />
        );
      case 3:
        return (
          <MissingDocument
            documentAnalysisResponse={documentAnalysisResponse}
            setDocumentAnalysisResponse={setDocumentAnalysisResponse}
            user={user}
            formHandler={formHandler}
            selectedOnboardingUsers={selectedOnboardingUsers}
            setSelectedOnboardingUsers={setSelectedOnboardingUsers}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            isEditMode={isEditMode}
          />
        );
      case 4:
        return (
          <AuthenticateYourId
            formHandler={formHandler}
            user={user}
            isGuarantor={isGuarantor}
            updateUserProfile={upsertUserProfile}
            setRunDetectKycDocs={setRunDetectKycDocs}
            isEditMode={isEditMode}
            addedFiles={addedFiles}
            setAddedFiles={setAddedFiles}
          />
        );
      case 5:
        return (
          <DocumentScanning
            user={user}
            formHandler={formHandler}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            runDetectKycDocs={runDetectKycDocs}
            isEditMode={isEditMode}
            setAddedFiles={setAddedFiles}
          />
        );

      case 6:
        return (
          <BankModal
            user={user}
            formHandler={formHandler}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            loadGuarantorData={loadGuarantorData}
            guarantor_a_id={guarantor_a_id}
            originalUser={originalUser}
            isEditMode={isEditMode}
          />
        );

      case 7:
        return (
          <GuarantorModal
            user={user}
            formHandler={formHandler}
            updateUserProfile={upsertUserProfile}
            isGuarantor={isGuarantor}
            originalUser={originalUser}
            isEditMode={isEditMode}
          />
        );

      case 8:
        return (
          <FreeTextModal
            user={user}
            showFreeTextPopup={true}
            updateTenantData={upsertUserProfile}
            originalUser={originalUser}
          />
        );

      case 9:
        return (
          <ConsentStepModal
            user={user}
            updateTenantData={upsertUserProfile}
            originalUser={originalUser}
          />
        );

      default:
        return (
          <BasicInfoModal
            user={user}
            formData={formData}
            setFormData={setFormData}
            createUserProfile={upsertUserProfile}
            formHandler={formHandler}
            requiresSubcategory={requiresSubcategory}
            isGuarantor={isGuarantor}
            guarantorAccountPresent={guarantorAccountPresent}
            originalUser={originalUser}
            setGuarantorAccountPresent={setGuarantorAccountPresent}
            isEditMode={isEditMode}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            selectedProtectedHousingDocs={selectedProtectedHousingDocs}
            setSelectedProtectedHousingDocs={setSelectedProtectedHousingDocs}
          />
        );
    }
  };

  return (
    <>
      {pageLoading ? (
        <div id="main-app-loader">
          <Loader />
        </div>
      ) : (
        renderStep()
      )}
      {showGuarantorModel && (
        <div className="approvedModal popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen">
          <div className="popup-content2 popup-content bg-white guarantorDocuments">
            <div className="row">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-between heading-section">
                <div>
                  <h4>{_t("wouldYouLikeToProvideGuarantorDocuments")}</h4>
                </div>
                <div className="canceiconwrapper">
                  <img
                    src={Cancelimg}
                    alt="icon"
                    className="canceicon"
                    onClick={(e) => navigate("/home")}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <p className="tenant-doc-text">
                    {_t(
                      "continueUploadingGuarantorInfoDocumentsOnBehalfOPfTheGuarantorOrYouCanRequestYourGuarantorToProvideTheirInfoAndDocumentsOnTheirOwn"
                    )}
                  </p>
                </div>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-center custom-gap-3 buttonWrapperDocument custom-mt-4 custom-mb-2">
              <button
                type="button"
                className="btnNext btnnextpre w-100"
                onClick={() => setlessGuarantorInfoModal(true)}
              >
                {_t("sendRequestToProvideDocuments")}
              </button>
              <button
                type="button"
                className="btnNext w-100"
                onClick={(e) => setShowGuarantorModel(false)}
              >
                {_t("provideGuarantorDocments")}
              </button>
            </div>
          </div>
        </div>
      )}
      {lessGuarantorInfoModal && (
        <FlatmateOrGuarantorAddForm
          isOpen={lessGuarantorInfoModal}
          onClose={() => {
            setlessGuarantorInfoModal(false);
          }}
          setModal={setlessGuarantorInfoModal}
          isGuarantor={isGuarantor}
          handleSendEmailToGuarantor={handleSendEmailToGuarantor}
        />
      )}
      <PendingRequestsPopup
        handleAcceptModal={() => setIsAcceptModalOpen(true)}
        show={pendingGuaranteesRequests.length > 0}
        pendingGuarantees={pendingGuaranteesRequests}
        loadPendingGuarantees={loadPendingGuarantees}
        loading={pendingRequestsGuranteesLoading}
        setLoading={setPendingRequestsGuranteesLoading}
        showBackground={true}
        setPendingGuaranteesRequests={setPendingGuaranteesRequests}
        setAcceptedGuaranteeName={setAcceptedGuaranteeName}
      />

      <RequestAcceptingModal
        show={isAcceptModalOpen}
        onClose={() => setIsAcceptModalOpen(false)}
        acceptedGuaranteeName={acceptedGuaranteeName}
      />
    </>
  );
}

export default OnboardingMain;
